<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content [innerHTML]="description"></div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="'YES'">Schliessen</button>
</div>
